import Image from 'next/image';
import type { FC } from 'react';

import type { HeaderTranslations } from '@/translations';

import { Link } from '../link';

interface Props {
  data: HeaderTranslations;
}

export const SimpleHeader: FC<Props> = ({ data }) => {
  return (
    <header className="simple-header">
      <div className="simple-header--wrapper">
        <Link
          noStyle
          href={data.home.link?.uri || '#'}
          aria-label="Home"
          className="simple-header--logo"
        >
          <Image src="/logo.svg" alt="Logo" width={117} height={38} />
        </Link>
        <div className="simple-header--actions">
          <div className="simple-header--support">
            <Image
              src="/images/stand-with-ukraine.svg"
              alt="Stand with Ukraine"
              width={113}
              height={37}
              className="simple-header--support--img"
            />
          </div>
          <Link
            href="#how-to-proceed"
            theme="black"
            fill="full"
            title={data.getInTouch.text}
            className="simple-header--get-in-touch"
          >
            {data.getInTouch.text}
          </Link>
        </div>
      </div>
    </header>
  );
};
